import { CloseButton, Flex, Tabs, TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { FixAppHeight } from 'components/FixAppHeight';
import { PageTitle } from 'components/PageTitle';
import { i18nKeys, type TranslateFunction, useTranslation } from 'locales';
import { useState } from 'react';
import { useHistory } from 'react-router';
import { PaymentPlanTemplates } from './PaymentPlanTemplates';
import { RecoveryTemplates } from './RecoveryTemplates';

export const TemplateIndex = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const [searchQuery, setSearchQuery] = useState('');

  const tabItems = getTabItems(t, searchQuery);

  const [activePath, setActivePath] = useState(
    tabItems.find(item => item.path === location.pathname)?.path ?? tabItems[0].path,
  );

  return (
    <Flex direction="column" h="100%">
      <FixAppHeight />
      <PageTitle>
        {t(i18nKeys.DOCUMENT_CUSTOMIZATION)}
        <PageTitle.Actions>
          <TextInput
            w={260}
            value={searchQuery}
            onChange={event => setSearchQuery(event.currentTarget.value)}
            placeholder={t(i18nKeys.SEARCH)}
            leftSection={<IconSearch size={16} stroke={1.5} />}
            rightSection={
              searchQuery !== '' && <CloseButton size="sm" onClick={() => setSearchQuery('')} />
            }
            rightSectionPointerEvents={searchQuery !== '' ? 'all' : 'none'}
          />
        </PageTitle.Actions>
      </PageTitle>
      <Tabs
        value={activePath}
        onChange={value => {
          if (!value) return;
          setActivePath(value);
          history.push(value);
        }}
        style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}
      >
        <Tabs.List w="100%">
          {tabItems.map(({ path, title }) => (
            <Tabs.Tab key={path} value={path}>
              {title}
            </Tabs.Tab>
          ))}
        </Tabs.List>
        {tabItems.map(({ path, children }) => (
          <Tabs.Panel key={path} value={path} style={{ flex: 1, minHeight: 0 }}>
            {children}
          </Tabs.Panel>
        ))}
      </Tabs>
    </Flex>
  );
};

function getTabItems(t: TranslateFunction, searchQuery: string) {
  return [
    {
      title: t(i18nKeys.SETTINGS.TEMPLATES.TABS.RECOVERY),
      path: '/settings/templates/recovery',
      children: <RecoveryTemplates searchQuery={searchQuery} />,
    },
    {
      title: t(i18nKeys.PAYMENT_PLAN.TITLE.MANY),
      path: '/settings/templates/payment-plans',
      children: <PaymentPlanTemplates searchQuery={searchQuery} />,
    },
  ];
}
